import { useState, useEffect } from 'react';
import { Button, Table } from 'react-bootstrap';
import ProcessMapModal from './ProcessMapModal';
import { dedupedRequest } from '../../utils/axios';

const ProcessMapsPanel = () => {
  const [maps, setMaps] = useState([]);
  const [selectedMap, setSelectedMap] = useState<any | null>(null);

  const loadMaps = async () => {
    dedupedRequest({ method: 'GET', url: `/admin/process_maps` }, { useCache: true })
      .then(res => setMaps(res.data))
      .catch(err => console.error('Failed to load process maps:', err));
  };

  const handleRowClick = (map: any) => {
    dedupedRequest({ method: 'GET', url: `/admin/process_maps/${map.id}` }, { useCache: true })
      .then(res => setSelectedMap(res.data))
      .catch(err => console.error('Failed to load process map:', err));
  };

  const deleteMap = async (id: number) => {
    dedupedRequest({ method: 'DELETE', url: `/admin/process_maps/${id}` }, { useCache: true })
      .catch(err => console.error('Error deleting process map:', err));
    loadMaps();
  };

  useEffect(() => {
    loadMaps();
  }, []);

  return (
    <div>
      <h4>Process Maps</h4>
      <Table striped className="mt-4">
        <thead>
          <tr><th>ID</th><th>Client</th><th>Name</th><th>Actions</th></tr>
        </thead>
        <tbody>
          {maps.map((m: any) => (
            <tr key={m.id} onClick={() => handleRowClick(m)}>
              <td>{m.id}</td>
              <td>{m.client_name}</td>
              <td>{m.name}</td>
              <td><Button size="sm" variant="danger" onClick={() => deleteMap(m.id)}>Delete</Button></td>
            </tr>
          ))}
        </tbody>
      </Table>
      {selectedMap && (
      <ProcessMapModal
        show={!!selectedMap}
        handleClose={() => setSelectedMap(null)}
        map={selectedMap}
      />
      )}

    </div>
  );
};

export default ProcessMapsPanel;
